import React from 'react';
import type { IProps } from './types';
import {
  SequenceStepPriority,
  SequenceStepPriorityValue,
} from '../../../../../enums';
import { accessibleOnClick } from '../../../../../../../shared/utils/accessible-on-click';

const TaskPriority: React.FC<IProps> = ({
  selectedPriority,
  onPriorityChange,
}) => {
  const onSelect = (priority: SequenceStepPriority) => {
    const priorityId = SequenceStepPriorityValue[priority];
    onPriorityChange(priorityId);
  };

  return (
    <div className="task-priority">
      <span className="semibold-1 gray-txt-15">Task Priority</span>
      <div className="d-flex task-priority__items">
        {Object.values(SequenceStepPriority).map((priority) => (
          <div
            key={priority}
            {...accessibleOnClick(() => onSelect(priority))}
            className={`task-priority__item ${
              selectedPriority === SequenceStepPriorityValue[priority] &&
              `task-priority__item-active ${priority.toLowerCase()}`
            }`}
          >
            <span className="regular-1 font-medium line-height-20">
              {priority}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaskPriority;
